module.exports = __webpack_public_path__ + "img/banner_4.f6ba051b.jpg";